import React from "react";
import "./Contact.css";
import { MdOutlineMailOutline } from "react-icons/md";
import { BsLinkedin } from "react-icons/bs";
import { BsWhatsapp } from "react-icons/bs";
import { useRef } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_xskwm5m",
        "template_v2so1qg",
        form.current,
        "UzBofWPnQX9Sjcmfd"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineMailOutline className="contact__option-icon" />
            <h4>Emali</h4>
            <h5>Mayank.k.iiit@gmail.com</h5>
            <a href="mailto:Mayank.k.iiit@gmail.com" target=" ">
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <BsLinkedin className="contact__option-icon" />
            <h4>LinkedIn </h4>
            <h5>Mayank-kr-shah</h5>
            <a href="https://www.linkedin.com/in/mayank-kr-shah" target=" ">
              Send a message
            </a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4>Whatsapp</h4>
            <h5>+91 841 888 57**</h5>
            <a href="https://api.whatsapp.com/send?phone=8418885752" target=" ">
              Send a message
            </a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Enter Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <input type="text" name="subject" placeholder="Subject" required />
          <textarea
            name="message"
            id=""
            cols="30"
            rows="7"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary ex">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
